import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts'

import { ChartProps } from './type'
import { STANDARD_GRAPH_HEIGHT } from './constants'
import { Box, BoxProps } from '@chakra-ui/core'
import { randomColor } from '../../../../utils'
import { theme } from '../../../../theme'

type LineChartProps = ChartProps & BoxProps

const LineChartComponent: React.FC<LineChartProps> = ({
  data,
  xKey,
  yKey,
  barColor = theme.colors.brand[400],
  randomizeColors,
  ...rest
}) => {
  const processedData = React.useMemo(() => {
    const results = data?.map((entry) => ({
      ...entry,
      fill: randomizeColors ? randomColor() : barColor
    }))
    return results
  }, [data, randomizeColors, barColor])

  return (
    <Box w="100%" h="100%" fontSize="xs" {...rest}>
      <ResponsiveContainer height={STANDARD_GRAPH_HEIGHT}>
        <LineChart data={processedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey={yKey} stroke={barColor} />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default LineChartComponent
